import { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { resolveUsersDateRange } from "./usersDateDefaults";
import { readOnlyDateInputProps, readOnlyDateInputSx } from "../datePickerReadOnlyInput";

interface UsersFilterItemsProps {
  dateRange: [Dayjs | null, Dayjs | null];
  onDateRangeChange: (range: [Dayjs | null, Dayjs | null]) => void;
}

export default function UsersFilterItems({ dateRange, onDateRangeChange }: UsersFilterItemsProps) {
  const [resolvedStart, resolvedEnd] = resolveUsersDateRange(dateRange);

  const [draftStart, setDraftStart] = useState<Dayjs | null>(resolvedStart);
  const [draftEnd, setDraftEnd] = useState<Dayjs | null>(resolvedEnd);

  useEffect(() => {
    setDraftStart(resolvedStart);
    setDraftEnd(resolvedEnd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange]);

  const handleGetData = () => {
    onDateRangeChange([draftStart, draftEnd]);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={3} alignItems="center" flexWrap="wrap" useFlexGap>
        <DatePicker
          label="Start date"
          value={draftStart}
          maxDate={draftEnd ?? undefined}
          format="DD-MM-YYYY"
          enableAccessibleFieldDOMStructure={false}
          onChange={(value) => setDraftStart(value)}
          slotProps={{
            textField: {
              size: "small",
              color: "secondary",
              inputProps: readOnlyDateInputProps,
              sx: readOnlyDateInputSx,
              "data-tracker": "977",
            } as any,
          }}
        />
        <DatePicker
          label="End date"
          value={draftEnd}
          minDate={draftStart ?? undefined}
          format="DD-MM-YYYY"
          enableAccessibleFieldDOMStructure={false}
          onChange={(value) => setDraftEnd(value)}
          slotProps={{
            textField: {
              size: "small",
              color: "secondary",
              inputProps: readOnlyDateInputProps,
              sx: readOnlyDateInputSx,
              "data-tracker": "978",
            } as any,
          }}
        />
        <Button
          variant="contained"
          color="secondary"
          size="small"
          disableElevation
          onClick={handleGetData}
          disabled={!draftStart || !draftEnd}
          sx={{ height: 40 }}
        >
          Get data
        </Button>
      </Stack>
    </LocalizationProvider>
  );
}
